import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RepresentanteModalidadeComercialMultiselectComponent } from './representante-modalidade-comercial-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RepresentanteModalidadeComercialMultiselectComponent
    ],
    exports: [
        RepresentanteModalidadeComercialMultiselectComponent
    ]
})
export class RepresentanteModalidadeComercialMultiselectModule { }
